/*
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2025, Zumper
 */

export const BANNER_TYPE = {
  DETAIL: 'DETAIL',
  GALLERY: 'GALLERY',
  APP: 'APP',
  HOMEPAGE: 'HOMEPAGE',
  SEARCH: 'SEARCH',
  MESSAGING: 'MESSAGING',
} as const

export const DETAIL_BANNER_UTM = 'app_banner_detail'
export const HOME_BANNER_UTM = 'app_banner_home'
export const DETAIL_GALLERY_BANNER_UTM = 'app_banner_detail_gallery'
export const SEARCH_BANNER_UTM = 'app_banner_search'
export const MESSAGE_BANNER_UTM = 'app_banner_message'
export const APP_BANNER_UTM = 'app_banner_app'

export const BANNER_SUFFIXES = {
  IOS_MWEB_BANNER_SUFFIX: 'ios_mweb_banner',
  IOS_MWEB_RENTER_BANNER_SUFFIX: 'ios_comms_mweb_banner',
} as const

export const CT = 'ct'
export const MT = 'mt'
export const PT = 'pt'
export const MT_VALUE = '8'
export const PT_VALUE = '1870841'

export const ZUMPER_APPSFLYER_GENERIC_PID = 'zumper_web'
export const ZUMPER_APPSFLYER_IOS_PID = 'zumper_web_ios'
export const ZUMPER_APPSFLYER_ANDROID_PID = 'zumper_web_android'
export const PADMAPPER_APPSFLYER_IOS_PID = 'padmapper_web_ios'
export const PADMAPPER_APPSFLYER_ANDROID_PID = 'padmapper_web_android'
